module.exports = __webpack_public_path__ + "media/images/tick-44e85c3d247ab36f7c2652a0fada6eb8.png";